export function createImageApiUrl(originalUrl: string): string {
  const baseUrl = process.env.ORIGIN
  const apiUrl = process.env.API_URL

  if (!baseUrl || !apiUrl) {
    throw new Error("Environment variables ORIGIN and API_URL must be set")
  }

  // Extract the relative path from the original URL
  const relativePath = originalUrl.replace(apiUrl, "")

  // Construct the API URL
  return `${baseUrl}/api/ogimage${encodeURI(relativePath)}`
}
